/* "People also add" row in the cart drawer.
   Adds without leaving the drawer by asking /cart/add for a re-rendered cart-drawer
   section and handing it to Dawn's own CartDrawer.renderContents, which is the same
   path the quantity steppers use. The element is re-created every time the drawer
   re-renders, so connectedCallback re-binds the listener each time. */

if (!customElements.get('sb-cart-upsells')) {
  customElements.define(
    'sb-cart-upsells',
    class SbCartUpsells extends HTMLElement {
      connectedCallback() {
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.onSubmit);
        this.controller?.abort();
      }

      async onSubmit(event) {
        const form = event.target.closest('form.sb-up__form');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('button');
        const errorEl = this.querySelector('.sb-up__error');
        if (button.hasAttribute('aria-busy')) return;

        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        if (errorEl) errorEl.hidden = true;

        const body = new FormData(form);
        // Ask for the drawer markup back in the same round trip.
        body.append('sections', 'cart-drawer,cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        this.controller?.abort();
        this.controller = new AbortController();

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
            signal: this.controller.signal,
          });

          const state = await response.json();

          if (state.status) {
            // Shopify returns { status, message, description } on failure.
            throw new Error(state.description || state.message || 'Could not add that item.');
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && state.sections) {
            drawer.renderContents(state);
          } else {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-cart-upsells' });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          if (errorEl) {
            errorEl.textContent = error.message;
            errorEl.hidden = false;
          }
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
